///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ClearFilterIcon = ({
  height,
  fill = "#343434",
  title = messages.clearFilters.defaultMessage,
  width,
  ...props
}) => {
  return (
    <svg
      aria-labelledby="clear-filter-icon"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title id="clear-filter">{title}</title>
      <path
        fill={fill}
        d="M5 11a1 1 0 000 2h2l-1-2H5zM4 8H3a1 1 0 000 1h2L4 8zM2 4H1a1 1 0 000 2h2L2 4zm4 0L5 1H3L2 2h1l7 13h2v-1L9 9h1a1 1 0 000-1H8L7 6h5a1 1 0 000-2H6z"
      />
    </svg>
  );
};

export default ClearFilterIcon;
